<template>
  <div class="page">
    <div class="page-content" style="background-color:#ffffff">
  		<page-nav-bar currentServiceName="MoneyRoad" popoverName=".popoverDashboard" :subNavTitle="dashboard_Dashboard" :menuAccess="true"></page-nav-bar>

  		<div class="layoutTop"/>
      <div class="container-fluid">
        <div class="dashboardWelcome">
          <div class="dashboardWelcome-inner">{{ $t('dashboard.hello_label') }} {{userName}} !</div>
        </div>

        <status-cards-row v-for="CardsRow in statusCardsData"
          :key="CardsRow.key"
          :statusCards="CardsRow.values"
          :filterSendBox="filterLastMonth">
        </status-cards-row>

        <div class="row">
          <!-- Monthly activity graph -->
          <div class="col-lg-7">
            <div class="card">
              <card-header :label="barChartTitle"></card-header>
              <div class="card-content hiddenElement monthlyActivityGraph" :style="borderColors">
                <canvas class="barChart"></canvas>
              </div>
            </div>
          </div>
          <!-- Monthly activity calendar -->
          <div class="col-lg-5">
            <div class="card">
              <card-header :label="'dashboard.monthly_valid_transaction'"></card-header>
              <div class="card-content monthlyActivityGraph hiddenElement" :style="borderColors">
                <div class="calendar"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Monthly activity monitoring -->
          <div class="col-lg-12">
          <div class="data-table card">
            <card-header :label="'dashboard.monthly_activity'"></card-header>
            <div class="card-content hiddenElement" :style="borderColors">
              <monitoring-table :filterSendBox="filterLastMonth" :role="expectedRole"></monitoring-table>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Liste des comptes bancaires -->
        <div class="col-lg-7">
          <div class="card">
            <card-header :label="'dashboard.banks_and_cards'"></card-header>
            <div class="card-content hiddenElement logCards" :style="borderColors">
              <cm-bank-accounts-list :bankAccounts="bankAccounts" class="bankAccountDashboard" :SmallOnLargeScreen="true"></cm-bank-accounts-list>
              <!-- S'il n'y a aucun compte bancaire enregistré, on propose Ã  l'utilisateur d'en ajouter un -->
              <f7-list v-if="this.bankAccounts.length === 0">
                <f7-list-item @click="addBankAccount()" style='cursor:pointer;'>
                  <f7-icon f7="add_round" class="dashboardBankAdd"></f7-icon>
                </f7-list-item>
              </f7-list>
            </div>
          </div>
        </div>
        <!-- Résumé global des activités -->
        <div class="col-lg-5">
        		<div class="card">
              <card-header :label="'dashboard.activity_card_name'"></card-header>
        	    <div class="card-content hiddenElement logCards" :style="borderColors">
                <div class="card-content-inner">
        					<dashboard-list v-bind:inMessages="inboxMessages" :role="expectedRole"></dashboard-list>
                  <!-- S'il n'y a aucune transaction enregistrée, un message d'absence de transactions est affiché -->
                  <f7-list v-if="this.inboxMessages.length === 0">
                    <f7-list-item><div class="finalAction">{{ $t('common.no_action') }}</div></f7-list-item>
                  </f7-list>
        				</div>
        	    </div>
        		</div>
        </div>
      </div>
    </div>
        <div class="toolbarPageBottomBlank"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import BankAccountsList from '@/pages/bankAccounts/CMBankAccountsPage/CMBankAccountsList.vue'
import moment from 'moment'
import StatusCardsList from '@/pages/dashboard/dashboardComponents/StatusCardsList.vue'
import StatusCardData from '@/pages/dashboard/data/cardsData.json'
import MonitoringTable from '@/components/monitoringTable/monitoringTable.vue'
import DashboardList from '@/pages/dashboard/dashboardComponents/DashboardList.vue'
import CardHeader from '@/components/common/cardHeader.vue'
import Chart from 'chart.js'
import $ from 'jquery'
import 'fullcalendar'
import 'fullcalendar/dist/fullcalendar.css'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'cm-bank-accounts-list': BankAccountsList,
    'status-cards-row': StatusCardsList,
    'dashboard-list': DashboardList,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'card-header': CardHeader,
    'monitoring-table': MonitoringTable
  },
  data () {
    return {
      pilotageInfo: '',
      bankAccounts: this.$engine.bankAccounts.get(),
      userName: this.$engine.user.get().name,
      dashboard_Dashboard: '',
      barChartTitle: '',
      inboxMessages: [],
      statusCardsRawData: StatusCardData,
      statusCardsData: [],
      events: [],
      expectedRole: ''
    }
  },
  created () {
    this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
    this.pilotageInfo = this.$engine.dashboard.model
    this.commonfunctions = this.$engine.common.functions
    this.currentServiceInfo = this.$engine.services.getServiceById(this.$engine.user.currentService.id)
  },
  mounted () {
    let that = this
    this.dashboard_Dashboard = this.$i18n.t('leftPanelTitle.dshbrd')
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    this.expectedRole = 'creditor'
    this.barChartTitle = 'dashboard.monthly_activity_creditor'
    if (this.$engine.user.currentService.id === '6') {
      this.expectedRole = 'debtor'
      this.barChartTitle = 'dashboard.monthly_activity_debtor'
    }
    this.pilotageInfo.updateData({
      time: 'month',
      role: this.expectedRole,
      ifCalendar: '1'
    })
    .then(resp => {
      // TODO chart
      var barChartCanvas = document.getElementsByClassName('barChart')[document.getElementsByClassName('barChart').length - 1].getContext('2d')
      let amountLabelItem = this.$i18n.t('common.amnt')

      if (this.$engine.user.currentService.id === '6') {
        this.MonthlyCreditorData = this.pilotageInfo.dataAsDebtor.month
      } else {
        this.MonthlyCreditorData = this.pilotageInfo.dataAsCreditor.month
      }
      /** TLV 13/03/2020
      * Ajout des données pour le tableau des activités mensuelles
      * A adapter et unifier dans le dossier cardsData.json quand on aura du temps pour ça
      */
      let dataForChart = {
        labelsList: [
          this.$i18n.t('common.status.accepted_request').split(' '),
          this.$i18n.t('common.status.waiting_request').split(' ')
        ],
        computedData: {
          data: [
            parseInt(parseFloat(this.MonthlyCreditorData.validated.amount)),
            parseInt(this.MonthlyCreditorData.toBeTreated.amount)
          ],
          backgroundColor: [
            'rgba(81, 164, 92, 1)',
            '#f78100'
          ],
          borderColor: [
            'rgba(81, 164, 92, 1)',
            'rgba(249, 197, 43, 1)'
          ],
          borderWidth: 1
        }
      }
      // [RTP] NegotiationRequest, NegotiationResponse, CreditTransferGenerated et BankStatementReceived
      if (this.$engine.user.currentService.id === '1') {
        // Labels
        dataForChart.labelsList.push(
          this.$i18n.t('common.status.negotiation_request').split(' '),
          this.$i18n.t('common.status.negotiation_response').split(' '),
          this.$i18n.t('common.status.payment_order_generated').split(' '),
          this.$i18n.t('common.status.payment_made').split(' ')
        )
        let RequestAmount = 0
        let ResponseAmount = 0
        if (this.pilotageInfo.dataAsCreditor.month.negotiationRequest != null) {
          RequestAmount = this.pilotageInfo.dataAsCreditor.month.negotiationRequest.amount
        }
        if (this.pilotageInfo.dataAsCreditor.month.negotiationResponse != null) {
          ResponseAmount = this.pilotageInfo.dataAsCreditor.month.negotiationResponse.amount
        }
        // Data
        dataForChart.computedData.data.push(
          parseInt(RequestAmount),
          parseInt(ResponseAmount),
          parseInt(this.MonthlyCreditorData.bankStatementReceived.amount),
          parseInt(this.MonthlyCreditorData.transferReceived.amount)
        )
        // Background colors
        dataForChart.computedData.backgroundColor.push(
          'rgba(18, 188, 241, 1)',
          'rgba(87, 43, 116, 1)',
          'rgba(57, 204, 204, 1)',
          'rgba(90, 197, 148, 1)'
        )
        // Border colors
        dataForChart.computedData.borderColor.push(
          'rgba(18, 188, 241, 1)',
          'rgba(87, 43, 116, 1)',
          'rgba(57, 204, 204, 1)',
          'rgba(90, 197, 148, 1)'
        )
      }
      // (DP) PaymentSent and InstantPaymentSent
      if (this.$engine.user.currentService.id === '6') {
        // Labels
        dataForChart.labelsList.push(
          this.$i18n.t('common.status.payment_order_generated').split(' '),
          this.$i18n.t('common.status.payment_made').split(' ')
        )
        // Data
        dataForChart.computedData.data.push(
          parseInt(this.MonthlyCreditorData.bankStatementReceived.amount),
          parseInt(this.MonthlyCreditorData.transferReceived.amount)
        )
        // Background colors
        dataForChart.computedData.backgroundColor.push(
          'rgba(57, 204, 204, 1)',
          'rgba(90, 197, 148, 1)'
        )
        // Border colors
        dataForChart.computedData.borderColor.push(
          'rgba(57, 204, 204, 1)',
          'rgba(90, 197, 148, 1)'
        )
      }
      // [RTP et DP] RequestRevoked
      dataForChart.labelsList.push(
        this.$i18n.t('common.status.aborted_request').split(' ')
      )
      dataForChart.computedData.data.push(
        parseInt(this.MonthlyCreditorData.refused.amount)
      )
      dataForChart.computedData.backgroundColor.push(
        'rgba(229, 63, 78, 1)'
      )
      dataForChart.computedData.borderColor.push(
        'rgba(229, 63, 78, 1)'
      )

      var myChart = new Chart(barChartCanvas, {
        type: 'bar',
        options: {
          title: {
            display: false
          },
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem) {
                return amountLabelItem + ' ' + tooltipItem.yLabel + ' €'
              }
            }
          },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 11,
                fontStyle: 'bold',
                lineHeight: 10
              },
              gridLines: {
                display: false
              }
            }],
            yAxes: [{
              scaleLabel: {
                display: true,
                labelString: amountLabelItem + ' (€)'
              },
              ticks: {
                beginAtZero: true,
                fontSize: 9
              },
              gridLines: {
                display: false
              }
            }]
          }
        },
        data: {
          labels: dataForChart.labelsList,
          datasets: [dataForChart.computedData]
        }
      })

      myChart.update()
      let dataCreditor = this.MonthlyCreditorData
      /** TLV 06/03/2020 : Données qui vont Ãªtre envoyées au cartes
      * Pour chaque carte de chaque ligne, on précise le montant et le réel label */
      this.statusCardsRawData.rows.forEach(function (row) {
        row.values.forEach(function (card) {
          if (dataCreditor[card.amountDataParameter] != null) {
            card.amount = dataCreditor[card.amountDataParameter].amount
          } else {
            card.amount = 0
          }
        })
      })
      this.statusCardsData = this.statusCardsRawData.rows

      // Ajout des réceptions d'argent sur le calendrier
      for (let i = 0; i < this.pilotageInfo.calendarDataCreditor.length; i++) {
        let x = {
          title: '+' + this.pilotageInfo.calendarDataCreditor[i].amount + ' €',
          start: this.pilotageInfo.calendarDataCreditor[i].date,
          color: '#51a45c'
        }
        that.events.push(x)
      }
      // Censé ajouter les pertes d'argent, mais ça n'a pas l'air de bien fonctionner
      for (let i = 0; i < this.pilotageInfo.calendarDataDebtor.length; i++) {
        let x = {
          title: '-' + this.pilotageInfo.calendarDataDebtor[i].amount + ' €',
          start: this.pilotageInfo.calendarDataDebtor[i].date,
          color: '#e53f4e'
        }
        that.events.push(x)
      }
      // TODO chart
      // TODO calendar
      $('.calendar').fullCalendar({
        height: 'auto',
        contentHeight: 'auto',
        header: {
          left: '',
          center: 'title',
          right: ''
        },
        views: {
          timelineFourDays: {
            type: 'timeline',
            duration: { days: 4 }
          }
        },
        events: that.events
      })
      // TODO calendar
      this.currentServiceInfo.allAction({
        direction: 1,
        statusRequestAccepted: 1,
        statusCreditTransferGenerated: 1,
        statusBankStatementReceived: 1,
        dateBegin: moment().format('YYYY-MM-01'),
        dateEnd: moment().add(1, 'months').format('YYYY-MM-01')
      }).then(resp => {
        if (resp != null) {
          that.inboxMessages = resp
        }
        this.currentServiceInfo.allAction({
          direction: 0,
          statusRequestAccepted: 1,
          statusCreditTransferGenerated: 1,
          statusBankStatementReceived: 1,
          dateBegin: moment().format('YYYY-MM-01'),
          dateEnd: moment().add(1, 'months').format('YYYY-MM-01')
        }).then(resp => {
          if (resp != null) {
            that.inboxMessages = that.inboxMessages.concat(resp)
          }
          that.inboxMessages.map(message => {
            if (message.amount != null) {
              message.amt = message.amount
            }
            if (message.direction != null) {
              message.dir = message.direction
            }
            if (message.requestedExecutionDate != null) {
              message.reqstdExecDt = message.requestedExecutionDate
            }
            if (message.debtorName != null) {
              message.dbNm = message.debtorName
            }
            if (message.creditorName != null) {
              message.crNm = message.creditorName
            }
          })
        })
      })
      this.$f7.hidePreloader()
    })
    .catch(error => {
      errorMessageAlert(error, that)
    })
    this.$bus.$off('refresh-bank-accounts')
    this.$bus.on('refresh-bank-accounts', () => {
      this.bankAccounts = this.$engine.bankAccounts.get()
    })
  },
  methods: {
    addBankAccount () {
      loadPage(this, {url: '/bankAccounts/create/'})
    },
    changeCurrentRole (role) {
      if (this.currentRole !== role) {
        this.currentRole = role
        this.changePilotageTime('day')
      }
    },
    filterLastMonth (status) {
      switch (status) {
        case 'Validated':
          this.currentServiceInfo.filter.statusWaiting = 0
          this.currentServiceInfo.filter.statusNegotiationRequest = 0
          this.currentServiceInfo.filter.statusNegotiationResponse = 0
          this.currentServiceInfo.filter.statusRequestAccepted = 1
          this.currentServiceInfo.filter.statusRequestAborted = 0
          this.currentServiceInfo.filter.statusCreditTransferGenerated = 0
          this.currentServiceInfo.filter.statusBankStatementReceived = 0
          this.currentServiceInfo.filter.statusDirectPayments = 0
          break
        case 'Modified':
          this.currentServiceInfo.filter.statusWaiting = 0
          this.currentServiceInfo.filter.statusNegotiationRequest = 0
          this.currentServiceInfo.filter.statusNegotiationResponse = 0
          this.currentServiceInfo.filter.statusRequestAccepted = 0
          this.currentServiceInfo.filter.statusRequestAborted = 0
          this.currentServiceInfo.filter.statusCreditTransferGenerated = 0
          this.currentServiceInfo.filter.statusBankStatementReceived = 0
          this.currentServiceInfo.filter.statusDirectPayments = 0
          break
        case 'Waiting':
          this.currentServiceInfo.filter.statusWaiting = 1
          this.currentServiceInfo.filter.statusNegotiationRequest = 0
          this.currentServiceInfo.filter.statusNegotiationResponse = 0
          this.currentServiceInfo.filter.statusRequestAccepted = 0
          this.currentServiceInfo.filter.statusRequestAborted = 0
          this.currentServiceInfo.filter.statusCreditTransferGenerated = 0
          this.currentServiceInfo.filter.statusBankStatementReceived = 0
          this.currentServiceInfo.filter.statusDirectPayments = 0
          break
        case 'Revoked':
          this.currentServiceInfo.filter.statusWaiting = 0
          this.currentServiceInfo.filter.statusNegotiationRequest = 0
          this.currentServiceInfo.filter.statusNegotiationResponse = 0
          this.currentServiceInfo.filter.statusRequestAccepted = 0
          this.currentServiceInfo.filter.statusRequestAborted = 1
          this.currentServiceInfo.filter.statusCreditTransferGenerated = 0
          this.currentServiceInfo.filter.statusBankStatementReceived = 0
          this.currentServiceInfo.filter.statusDirectPayments = 0
          break
        case 'NegotiationRequest':
          this.currentServiceInfo.filter.statusWaiting = 0
          this.currentServiceInfo.filter.statusNegotiationRequest = 1
          this.currentServiceInfo.filter.statusNegotiationResponse = 0
          this.currentServiceInfo.filter.statusRequestAccepted = 0
          this.currentServiceInfo.filter.statusRequestAborted = 0
          this.currentServiceInfo.filter.statusCreditTransferGenerated = 0
          this.currentServiceInfo.filter.statusBankStatementReceived = 0
          this.currentServiceInfo.filter.statusDirectPayments = 0
          break
        case 'NegotiationResponse':
          this.currentServiceInfo.filter.statusWaiting = 0
          this.currentServiceInfo.filter.statusNegotiationRequest = 0
          this.currentServiceInfo.filter.statusNegotiationResponse = 1
          this.currentServiceInfo.filter.statusRequestAccepted = 0
          this.currentServiceInfo.filter.statusRequestAborted = 0
          this.currentServiceInfo.filter.statusCreditTransferGenerated = 0
          this.currentServiceInfo.filter.statusBankStatementReceived = 0
          this.currentServiceInfo.filter.statusDirectPayments = 0
          break
        case 'Pain001Generated':
          this.currentServiceInfo.filter.statusWaiting = 0
          this.currentServiceInfo.filter.statusNegotiationRequest = 0
          this.currentServiceInfo.filter.statusNegotiationResponse = 0
          this.currentServiceInfo.filter.statusRequestAccepted = 0
          this.currentServiceInfo.filter.statusRequestAborted = 0
          this.currentServiceInfo.filter.statusCreditTransferGenerated = 1
          this.currentServiceInfo.filter.statusBankStatementReceived = 0
          this.currentServiceInfo.filter.statusDirectPayments = 0
          break
        case 'Camt053Generated':
          this.currentServiceInfo.filter.statusWaiting = 0
          this.currentServiceInfo.filter.statusNegotiationRequest = 0
          this.currentServiceInfo.filter.statusNegotiationResponse = 0
          this.currentServiceInfo.filter.statusRequestAccepted = 0
          this.currentServiceInfo.filter.statusRequestAborted = 0
          this.currentServiceInfo.filter.statusCreditTransferGenerated = 0
          this.currentServiceInfo.filter.statusBankStatementReceived = 1
          this.currentServiceInfo.filter.statusDirectPayments = 0
          break
        default:
      }
      let dateBegin = ''
      let dateEnd = ''
      let today = moment()
      dateBegin = today.format('YYYY-MM-01')
      dateEnd = today.add(1, 'day').format('YYYY-MM-DD')
      this.currentServiceInfo.filter.dateBegin = dateBegin
      this.currentServiceInfo.filter.dateEnd = dateEnd
      loadPage(this, {
        url: this.$engine.services.getUrlFromService(this.$engine.user.currentService.id) + 'sendbox' + '/'
      })
    }
  },
  computed: {
    borderColors () {
      let borderstyle = '2px solid ' + this.$engine.services.getCardBackgroundColor(this.$engine.user.currentService.id)
      return {
        borderBottom: borderstyle
      }
    }
  }
}
</script>

<style>
.dashboardWelcome {
  color:black;
  height: 70px;
  padding-bottom: 10px;
}
/* TLV 12/03/2020 : On force l'alignement vertical des cartes avec les boutons de status */
.card {
  margin: 5px !important;
}
.dashboardWelcome-inner {
  display: block;
  text-align: center;
  padding-top: 30px;
  font-size: 17px;
  font-weight: bold;
}
.pilotageIcon {
  font-size: 14px;
  padding: 0px 5px 0px 0px;
}
.dashboardTotalFooter{
  color:#ffd210;
  font-size: 20px;
}
.dashboardBankAdd {
  color: #a5a5a5;
  margin:auto;
}
.finalAction {
  color: #a5a5a5;
  margin:auto;
}
.table-block-container {
  overflow:hidden;
}
.table-block {
  width:33.3%;
  float: left;
  font-size:11px;
  color:white;
}
/* TLV 24/03/2020 : largeur des blocks quand il y a 4 cartes sur la mÃªme ligne */
.table-block-small {
  width: 25% !important;
}
.table-block-inner {
  margin: 5px 5px;
  padding: 6px 0px;
  border-radius:3px;
}
.table-block-amount {
  text-align: center;
  font-size:15px;
}
@media (min-width: 768px) {
  .table-block-label {
    text-align: center;
    padding-left: 40%;
    padding-right: 40%;
  }
  .large-table-block-label {
    text-align: center;
    padding-left: 35%;
    padding-right: 35%;
  }
  .monthlyActivityGraph {
    height: 440px !important
  }
  .logCards {
    height: 250px !important;
    overflow-y: scroll;
  }
}

@media (max-width: 768px) {
  .table-block-label {
    text-align: center;
    padding-left: 20%;
    padding-right: 20%;
  }
  .large-table-block-label {
    text-align: center;
    padding-left: 10%;
    padding-right: 10%;
  }
}
.greenBlock {
  background-color:#51a45c;
}
.redBlock {
  background-color:#f56954;
}
.yellowBlock {
  /* background-color:#ffd210; */
  background-color:#f78100ba;
}
.lightGreenBlock {
  background-color:#39cccc;
}
.lightGreenBlock2 {
  background-color:#65C694;
}
.blueBlock {
  background-color:#3c8dbc;
}
.purpleBlock {
  background-color:#7f2f7d;
}
.lightBlueBlock {
  background-color:#12bcf1;
}
.calendar {
  padding:5px;
  background-color:#ffffff;
}
.barChart {
  padding-top:10px;
  width:100%;
}
.bankAccountDashboard {
  width: auto;
  margin-left: 0%;
  margin-right: 0%;
}

/* TLV 13/03/2020
* A la demande de Nicolas, les ajouts d'argent sur le calendrier passent en gras et en blanc
*/
.fc-title {
  color: #FFF;
  font-weight: bold;
}

/* TLV 02/12/2019 : On rehausse un peu le dashboard sur grand écran */
@media (min-width:992px) {
  .container{
    margin-top: 100px;
  }
}

/* TLV 26/03/2020 : sur le dashboard uniquement, on n'affiche pas les iban ou sort code directement sur la liste
* et on enlèe default sur certaines largeurs */
.bankIbanLarge {
  display: none;
}

@media (max-width: 1500px) {
  .defaultLabelLarge {
    display:none !important;
  }
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?30805bbc